import Image from 'global/Image';

import {
  NonSyariahBannerWrapper,
  NonSyariahBannerDescription,
} from '../components.styled';

interface NonSyariahBannerProps {
  children: React.ReactNode;
}

export default function NonSyariahBanner({ children }: NonSyariahBannerProps) {
  return (
    <NonSyariahBannerWrapper>
      <Image
        src="/images/syariah/info-danger.svg"
        alt="Info"
        height="18"
        width="18"
      />

      <NonSyariahBannerDescription>{children}</NonSyariahBannerDescription>
    </NonSyariahBannerWrapper>
  );
}
